import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, enableNetwork } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD4ZwTMeGoTFHcEo2_7S9VgezkJdR71DYY",
  authDomain: "govassist-fd0bf.firebaseapp.com",
  projectId: "govassist-fd0bf",
  storageBucket: "govassist-fd0bf.appspot.com",
  messagingSenderId: "611511690283",
  appId: "1:611511690283:web:9b9c9aa35a6cf530bc766e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// Try to enable Firestore network
enableNetwork(db).catch((error) => console.error("Error enabling Firestore network:", error));

export { auth, db };
